module.exports = __webpack_public_path__ + "img/hsbc.2c93ec97.svg";